import * as React from "react"
import { createStyles, makeStyles, Theme } from "@material-ui/core/styles"
import mobileGraduallyLaunchImg from "../../../assets/images/featureFlag/gradually_launch_mobile.png"
import graduallyLaunchImg from "../../../assets/images/featureFlag/gradually_launch.png"
import mobileGraduallyLaunchImgEn from "../../../assets/images/featureFlag/gradually_launch_mobile_en.png"
import graduallyLaunchImgEn from "../../../assets/images/featureFlag/gradually_launch_en.png"
import usePlatform from "../../../hooks/usePlatform"
import { Locale } from "../../../locale"

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      backgroundColor: "#F9FAFB",
      [theme.breakpoints.up("md")]: {},
    },
    wrapper: {
      boxSizing: "border-box",
      width: "100%",
      "& img": {
        width: "100%",
      },
      [theme.breakpoints.up("md")]: {
        width: "1248px",
        margin: "0 auto",
        fontSize: 0,
      },
    },
  })
)

export default function GraduallyLaunch() {
  const classes = useStyles()
  const { isMobile } = usePlatform()
  const { lang } = Locale.getDefault()

  return (
    <div className={classes.root}>
      <div className={classes.wrapper}>
        {lang === "ko" ? (
          <img src={isMobile ? mobileGraduallyLaunchImg : graduallyLaunchImg} />
        ) : (
          <img src={isMobile ? mobileGraduallyLaunchImgEn : graduallyLaunchImgEn} />
        )}
      </div>
    </div>
  )
}
